export default {
    notVerified: 0,
    notFound: 1,
    verified: 2,
    used: 3,
    declinedAlready: 4,
    declining: 5,
    declinedSuccessfully: 6,
    submittedSuccessfully: 7
}


// WEBPACK FOOTER //
// ./src/constants/reference-code-workflow-status.js